"use client";
import React from "react";
import { motion } from "framer-motion";
import Heading from "@/components/molecules/Heading";
import WrapperBlueStyle from "@/components/atoms/wrapper-blue-style";
import { IInfoListWithImageBlock } from "@/page-builder/fragments/InfoListWithImageBlock/types";
import BupiLinkButton from "@/components/atoms/linkButton";
import { convertLexicalWithInternalLinks } from "@/lib/lexical";
import BupiLink from "@/components/atoms/link";
import { getAccessibleImageProps } from "@/lib/image-alt";
export const InfoListWithImageBlock: React.FC<IInfoListWithImageBlock> = ({
  items,
  background,
}) => {
  const Content = () => (<section
    className={` py-64 md:py-96 space-y-32 md:space-y-64 text-[#2B363C] `}
  >
    {items?.map((info, index) => (<div key={index} className="mx-auto container flex flex-col gap-32">

      <div
        className={`grid grid-cols-1 xl:grid-cols-8 md:items-center gap-32`}
      >
        <div
          className={`relative flex col-span-4 justify-end ${info?.position === "right" ? "order-1 xl:order-2" : "order-1"}`}
        >
          <motion.img
            width={592}
            height={592}
            src={info?.image?.url || ""}
            {...getAccessibleImageProps(info?.image?.alt)}
            className="w-full max-w-[296px] md:max-w-[468px] xl:max-w-[592px] h-auto z-0 mx-auto"
            initial={{ opacity: 0, x: info?.position === "right" ? 80 : -80 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
              x: { duration: 2, ease: "easeOut" },
              opacity: { duration: 1.5 }
            }}
          />
        </div>
        <div
          className={`flex col-span-4 flex-col md:items-start justify-center space-y-24 ${info?.position === "right" ? "order-2 xl:order-1" : "order-2"}`}
        >
          <Heading title={info?.title} />
          <div
            dangerouslySetInnerHTML={{ __html: convertLexicalWithInternalLinks( info?.description as any ) }}
            className="text-m-regular prose prose-ul:my-0 marker:text-neutral-900"
          />
          
          {info?.ctaButton?.url && info?.ctaButton?.label && 
            info.ctaButton.style === "solid" ? <BupiLinkButton
            label={info?.ctaButton?.label}
            link={info?.ctaButton?.url}
            target={info?.ctaButton?.target || "_self"}
            hasIcon
            leadingIcon="agora-line-arrow-right-circle"
          /> : (
                <BupiLink
                  label={info?.ctaButton?.label}
                  url={info?.ctaButton?.url || ""}
                  target={info?.ctaButton?.target || "_self"}
                  hasIcon
                />
              )
          }
        </div>
      </div>
    </div>))}
  </section >);
  return background === "green" ? (
    <WrapperBlueStyle>
      <Content />
    </WrapperBlueStyle>
  ) : (
    <Content />
  );
};
